<template>
    <div class="px-4 py-8 sm:px-10">
        <h2 class="text-lg leading-6 font-medium text-gray-900">{{ t('home.body:headline') }}</h2>
        <div>
            <p class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2 mb-4">{{ t('home.body:subline') }}</p>
            <div class="mt-1 sm:mt-0 sm:col-span-2">
                <Link :href="route('loc_create', {metaDataType: metaDataType.url})" method="POST">Los gehts</Link>
            </div>
        </div>
    </div>

</template>

<script setup>
import {usePage} from "@inertiajs/inertia-vue3";
import translate from "../../lang";
import { Link } from '@inertiajs/inertia-vue3'
let props = defineProps({
    metaDataType: Object
});
console.log(props.metaDataType);
let t = translate('upload-' + usePage().props.value.metaDataType.type);
</script>
